export { VideoRecorder } from './VideoRecorder';
export type { VideoRecorderProps } from './VideoRecorder';
export { VideoRecorderPure } from './VideoRecorderPure';
export type { VideoRecorderPhase, VideoRecorderPureProps } from './VideoRecorderPure';
export { browserVideoMediaStrategy } from './videoRecorder.utils';
export type { TeleprompterSpeed, VideoMediaStrategy } from './videoRecorder.utils';
